import { apiClient } from '../../../../helpers/api_helper';

export const getAllSalesEntryListData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/SalesEntry/GetSalesEntryList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getSalesEntryDetailsById = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/SalesEntry/GenerateSalesInvoice?invoiceNo=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getSalesEntryProductDetails = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/SalesInventory/GetSalesOrderItemBySalesOrderId?salesOrderId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}